import { ActionReducerMapBuilder, AsyncThunk } from '@reduxjs/toolkit';
import { FETCH_STATUS } from '../../types/enums/fetch-status.enum';
import { PaginationType } from '../../types/utils/pagination.type';
import snackbarUtils from '../../utils/SnackbarUtils';
import { RootReducerState } from '../../redux/Reducers';
import type { LocationsState } from './locations.slice';

type LocationTabListStateKeys = {
  list: keyof Pick<LocationsState, 'locationTicketsTabList' | 'locationOrdersTabList' | 'locationServiceCallsTabList'>;
  status: keyof Pick<
    LocationsState,
    'locationTicketsTabListFetchStatus' | 'locationOrdersTabListFetchStatus' | 'locationServiceCallsTabListFetchStatus'
  >;
};

export const addLocationTabListReducerCases = <T>(
  builder: ActionReducerMapBuilder<LocationsState>,
  thunk: AsyncThunk<PaginationType<T>, unknown, { state: RootReducerState }>,
  keys: LocationTabListStateKeys,
  errorFallback: string
): void => {
  builder
    .addCase(thunk.pending, state => {
      state[keys.status] = FETCH_STATUS.PENDING;
    })
    .addCase(thunk.rejected, (state, action) => {
      state[keys.status] = FETCH_STATUS.REJECTED;
      state[keys.list] = null;
      setTimeout(() => {
        snackbarUtils.error((action.payload as string) || errorFallback);
      });
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state[keys.status] = FETCH_STATUS.FULFILLED;
      state[keys.list] = action.payload;
    });
};
